import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractComponent, AuthenticationService, UtilHelper } from 'lib-trend-core';
import { Constants } from '../../../environments/constantes';

@Component({
    selector: 'redirect-component',
    templateUrl: 'redirect.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RedirectComponent extends AbstractComponent implements OnInit {

  public returnUrl: string;

  constructor(
    private authenticationService: AuthenticationService,
    public injector: Injector
  ) {
    super(injector);
  }

  ngOnInit() {
    const token = super.getQueryParam('token');
    const json = UtilHelper.getGeneratedTokenTowardsApps(token);
    const idUser = json.idUser;
    const idCompany = json.idCompany;

    this.authenticationService.loginImpersonate(idUser, idCompany).subscribe({
      next: (payload: any) => {
        // Every new login brings back the sidebar mobile-app promo the user may have hidden.
        localStorage.removeItem(Constants.mobileAppPromoDismissed);
        this.router.navigate(['/'])
      },
      error: err => this.alertService.error(err.error.message)
    });
  }

}
